import { P2, P3 } from '../../../styles/FontStyles';
import { Box, Button, Flexed } from '../../../styles/GlobalComponents';
import { Qualification } from '../CashbackBonusStyled';
import { Responsive } from '../../../styles/stylesStyled';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import {
  PLATFORM_LINK,
  USDT,
  copyLink,
  formatUSD
} from '../../../helpers/helperFunctions';
import { BIG_WHALE, ENTRY_PACKAGE, TRADING } from '../../../routes/routes';
import { color } from '../../../styles/GlobalStyles';
import {
  CashbackBonusInfoModel,
  CashbackBonusStatusPerPackageModel,
  DirectUser
} from '../CashbackBonus.types';
import { PartnerComponent } from '../PartnerComponent';

export const Section2 = ({
  cashback,
  statusPerPackage
}: {
  cashback: CashbackBonusInfoModel;
  statusPerPackage: CashbackBonusStatusPerPackageModel[];
}) => {
  const { t } = useTranslation('cashback');

  const { user } = useAppSelector((state) => state.auth.userInfo);
  const history = useHistory();

  return (
    <Box>
      <Qualification style={{ marginBottom: 40 }}>
        <div>
          <P2 mb='8' bold flex between>
            {t('section2.title')}
          </P2>
          <P3>
            {t('section2.text')}{' '}
            <b>
              {cashback?.currentPackagePrice ? (
                <>
                  {formatUSD(cashback?.currentPackagePrice)} {USDT}
                </>
              ) : (
                <span
                  style={{
                    color: color.colors.neutral900,
                    cursor: 'pointer'
                  }}
                  onClick={() => history.push(BIG_WHALE)}>
                  No HUB, buy now
                </span>
              )}
            </b>
          </P3>
        </div>

        <Flexed center widthSM='100%' gap='30px' gapSM='24px'>
          <Button
            w='200px'
            wSM='100%'
            negative
            onClick={() => history.push('/backoffice/my-team')}>
            {t('section2.button1')}
          </Button>
          <Button
            w='200px'
            wSM='100%'
            onClick={() =>
              copyLink(
                `${PLATFORM_LINK}/ambassador/${user?.referralCode}/${user?.id}`
              )
            }>
            {t('section2.button2')}
          </Button>
        </Flexed>
      </Qualification>

      <>
        {statusPerPackage.map(
          (
            {
              hubNames,
              directUsers,
              boughtHub
            }: CashbackBonusStatusPerPackageModel,
            i: number
          ) => {
            return (
              <Responsive mbSM='24' key={i} between center startSM>
                <div>
                  <P2
                    mb='8'
                    bold
                    flex
                    between
                    color={
                      boughtHub
                        ? color.colors.primary900
                        : color.colors.neutral400
                    }>
                    {hubNames}
                  </P2>
                  {boughtHub ? (
                    <P3 mb='8'>
                      {t('section2.order_id')} {boughtHub.userPackageId}{' '}
                      {t('section2.payment_date')}{' '}
                      {moment(boughtHub.datePaid).format('DD.M.YYYY')}
                    </P3>
                  ) : (
                    <Button
                      w='auto'
                      h='auto'
                      wSM='auto'
                      hSM='auto'
                      p='0'
                      mb='8'
                      textButton
                      onClick={() => history.push(ENTRY_PACKAGE)}>
                      {t('section2.button3')}
                    </Button>
                  )}
                </div>
                <Flexed wrap justifyCenter>
                  {directUsers.map((user: DirectUser, i: number) => {
                    return <PartnerComponent directUser={user} key={i} />;
                  })}
                </Flexed>
              </Responsive>
            );
          }
        )}
      </>
    </Box>
  );
};
